import axios from "../service/axios/axios";

export default {
  //获取项目列表
  getProductlists(data) {
    return axios({
      method: "post",
      url: "platform/Product/getProductlists",
      data: data,
    });
  },
  //获取项目详情
  getProductDetail({ pro_id }) {
    return axios({
      method: "post",
      url: "platform/Product/getProductDetail",
      data: { pro_id },
    });
  },
  //编辑项目状态 1启用，0不启用
  updateproductstatus({ pro_id, status }) {
    return axios({
      method: "post",
      url: "platform/Product/updateproductstatus",
      data: { pro_id, status },
    });
  },
  //创建项目
  addproduct({ pro_name, pro_type }) {
    return axios({
      method: "post",
      url: "platform/Product/addproduct",
      data: { pro_name, pro_type },
    });
  },
  //编辑项目详情
  editProductDetail(data) {
    return axios({
      method: "post",
      url: "platform/Product/editProductDetail",
      data: data,
    });
  },
  //获取医生推荐列表
  getDoctorRecommendLists(data) {
    return axios({
      method: "post",
      url: "platform/Product/getDoctorRecommendLists",
      data: data,
    });
  },
  //获取医生推荐详情
  getDoctorRecommendDetails({ recommend_id }) {
    return axios({
      method: "post",
      url: "platform/Product/getDoctorRecommendDetails",
      data: { recommend_id },
    });
  },
  //获取项目订单列表
  getProductOrders(data) {
    return axios({
      method: "post",
      url: "platform/Product/getProductOrders",
      data: data,
    });
  },
  // 获取项目订单详情
  getProductOrderDetail({ order_id }) {
    return axios({
      method: "post",
      url: "platform/Product/getProductOrderDetail",
      data: { order_id },
    });
  },
  // 完成订单
  updateProductOrderStatus({ order_id }) {
    return axios({
      method: "post",
      url: "platform/Product/updateProductOrderStatus",
      data: { order_id },
    });
  },
  // 项目订单退款
  refundProductOrder({ order_id }) {
    return axios({
      method: "post",
      url: "platform/Product/refundProductOrder",
      data: { order_id },
    });
  },
  // 提醒完善体检人信息
  writeMessagePush({ order_id }) {
    return axios({
      method: "post",
      url: "platform/Product/writeMessagePush",
      data: { order_id },
    });
  },
  /* **** 医生端活动配置 **** */
  // 医生端活动配置
  getDoctorBannerList(data) {
    return axios({
      method: "post",
      url: "platform/Activity/getDoctorBannerList",
      data: data,
    });
  },
  // 医生端活动配置排序
  editDoctorBannerSort(data) {
    return axios({
      method: "post",
      url: "platform/Activity/editDoctorBannerSort",
      data: data,
    });
  },
  // 获取医生端活动配置详情
  getDoctorBannerInfo(data) {
    return axios({
      method: "post",
      url: "platform/Activity/getDoctorBannerInfo",
      data: data,
    });
  },
  // 新增或修改医生端活动配置
  saveDoctorBanner(data) {
    return axios({
      method: "post",
      url: "platform/Activity/saveDoctorBanner",
      data: data,
    });
  },
  // 删除
  delDoctorBanner(data) {
    return axios({
      method: "post",
      url: "platform/Activity/delDoctorBanner",
      data: data,
    });
  },
  // 下架、发布医生端活动配置
  offOnDoctorBanner(data) {
    return axios({
      method: "post",
      url: "platform/Activity/offOnDoctorBanner",
      data: data,
    });
  },
  // 医生活动页配置列表
  getDoctorActivityList(data) {
    return axios({
      method: "post",
      url: "platform/Activity/getDoctorActivityList",
      data: data,
    });
  },
  // 商品兑换配置列表
  heartActivityGoodsList(data) {
    return axios({
      method: "post",
      url: "/platform/Activity/heartActivityGoodsList",
      data: data,
    });
  },
  // 商品兑换配置导出
  heartActivityGoodsListExport(data) {
    return axios({
      method: "post",
      url: "/platform/Activity/heartActivityGoodsListExport",
      data: data,
    });
  },
  // 新增兑换商品
  addHeartActivityGoods(data) {
    return axios({
      method: "post",
      url: "/platform/Activity/addHeartActivityGoods",
      data: data,
    });
  },
  // 修改商品是否展示
  updateActivityDoctorShow(data) {
    return axios({
      method: "post",
      url: "platform/Activity/updateActivityDoctorShow",
      data: data,
    });
  },
  //  删除兑换商品
  delHeartActivityGoods(data) {
    return axios({
      method: "post",
      url: "/platform/Activity/delHeartActivityGoods",
      data: data,
    });
  },
  //  兑换商品排序
  updateHeartActivityGoodsSort(data) {
    return axios({
      method: "post",
      url: "/platform/Activity/updateHeartActivityGoodsSort",
      data: data,
    });
  },
  // 极速问诊统计
  getUserConsultFastStatistics(data) {
    return axios({
      method: "post",
      url: "/platform/guidance/getUserConsultFastStatistics",
      data: data,
    });
  },
  // 极速问诊统计导出
  exportUserConsultFastStatistics(data) {
    return axios({
      method: "post",
      url: "/platform/guidance/exportUserConsultFastStatistics",
      data: data,
    });
  },
  // 医生活动页配置详情
  getDoctorActivityInfo(data) {
    return axios({
      method: "post",
      url: "platform/Activity/getDoctorActivityInfo",
      data: data,
    });
  },
  // 新增或修改医生端活动页配置
  saveDoctorActivity(data) {
    return axios({
      method: "post",
      url: "platform/Activity/saveDoctorActivity",
      data: data,
    });
  },
  // 下架、发布医生端活动页配置
  offOnDoctorActivity(data) {
    return axios({
      method: "post",
      url: "platform/Activity/offOnDoctorActivity",
      data: data,
    });
  },
  // 删除医生端活动页配置
  delDoctorActivity(data) {
    return axios({
      method: "post",
      url: "platform/Activity/delDoctorActivity",
      data: data,
    });
  },
  // 医生端活动页配置排序
  editDoctorActivitySort(data) {
    return axios({
      method: "post",
      url: "platform/Activity/editDoctorActivitySort",
      data: data,
    });
  },
  // 活动数据
  getDoctorBannerCount(data) {
    return axios({
      method: "post",
      url: "platform/Activity/getDoctorBannerCount",
      data: data,
    });
  },
  /* **** 医生活动列表 **** */
  // 医生活动列表
  doctorHeartActivityList(data) {
    return axios({
      method: "post",
      url: "platform/Activity/doctorHeartActivityList",
      data: data,
    });
  },
  // 活动作废
  isCancelDoctorHeartActivity(data) {
    return axios({
      method: "post",
      url: "platform/Activity/isCancelDoctorHeartActivity",
      data: data,
    });
  },
  // 查看（回显）
  getDoctorHeartActivity(data) {
    return axios({
      method: "post",
      url: "platform/Activity/getDoctorHeartActivity",
      data: data,
    });
  },
  // 添加活动
  saveDoctorHeartActivity(data) {
    return axios({
      method: "post",
      url: "platform/Activity/saveDoctorHeartActivity",
      data: data,
    });
  },
  // 编辑活动
  updateDoctorHeartActivity(data) {
    return axios({
      method: "post",
      url: "platform/Activity/updateDoctorHeartActivity",
      data: data,
    });
  },
  // 统计
  doctorHeartActivityCount(data) {
    return axios({
      method: "post",
      url: "platform/Activity/doctorHeartActivityCount",
      data: data,
    });
  },
  // 统计-合计总数居
  doctorHeartActivityTotalCount(data) {
    return axios({
      method: "post",
      url: "platform/Activity/doctorHeartActivityTotalCount",
      data: data,
    });
  },
  // 保存备注
  doctorHeartActivityRemark(data) {
    return axios({
      method: "post",
      url: "platform/Activity/doctorHeartActivityRemark",
      data: data,
    });
  },
  // 导入医生手机号
  uploadExcleDoctorHeartPhone(data) {
    return axios({
      method: "post",
      url: "platform/Activity/uploadExcleDoctorHeartPhone",
      data: data,
    });
  },
  // 导入活动统计数据
  importDoctorHeartActivityData(data) {
    return axios({
      method: "post",
      url: "platform/Activity/importDoctorHeartActivityData",
      data: data,
    });
  },
  // 详情
  doctorHeartActivityCountDetail(data) {
    return axios({
      method: "post",
      url: "platform/Activity/doctorHeartActivityCountDetail",
      data: data,
    });
  },
  // 养生卡退款
  refundCard(data) {
    return axios({
      method: "post",
      url: "platform/Healthcard/refundCard",
      data: data,
    });
  },
  // 养生卡退款记录
  healthcardRefundRecord(data) {
    return axios({
      method: "post",
      url: "platform/Healthcard/refundRecord",
      data: data,
    });
  },

  /* **** 医生仁心值记录 **** */
  // 医生仁心值记录
  doctorHeartAccountList(data) {
    return axios({
      method: "post",
      url: "platform/Activity/doctorHeartAccountList",
      data: data,
    });
  },
  // 医生仁心值明细
  doctorHeartAccountDetail(data) {
    return axios({
      method: "post",
      url: "platform/Activity/doctorHeartAccountDetail",
      data: data,
    });
  },
  // 医生仁心值明细导出
  exportDoctorHeartAccountDetail(data) {
    return axios({
      method: "post",
      url: "platform/Activity/exportDoctorHeartAccountDetail",
      data: data,
    });
  },
  // 添加明细
  addDoctorHeartAccountDetail(data) {
    return axios({
      method: "post",
      url: "platform/Activity/addDoctorHeartAccountDetail",
      data: data,
    });
  },
  // 医生仁心活动基础列表
  getJdShopConfig(data) {
    return axios({
      method: "post",
      url: "platform/Admin/getJdShopConfig",
      data: data,
    });
  },
  // 医生仁心值记录-三方退还数据
  doctorHeartActivityReturn(data) {
    return axios({
      method: "post",
      url: "platform/Activity/doctorHeartActivityReturn",
      data: data,
    });
  },
  /* **** 预约活动 **** */
  // 获取预约活动列表
  getListPaging(data) {
    return axios({
      method: "post",
      url: "platform/Registeractivity/getListPaging",
      data: data,
    });
  },
  // 获取预约活动详情
  getDetail(data) {
    return axios({
      method: "post",
      url: "platform/Registeractivity/getDetail",
      data: data,
    });
  },
  // 作废预约活动
  abandon(data) {
    return axios({
      method: "post",
      url: "platform/Registeractivity/abandon",
      data: data,
    });
  },
  // 新增预约活动
  create(data) {
    return axios({
      method: "post",
      url: "platform/Registeractivity/create",
      data: data,
    });
  },
  // 修改预约活动
  modify(data) {
    return axios({
      method: "post",
      url: "platform/Registeractivity/modify",
      data: data,
    });
  },
  // 获取预约记录列表
  getLogListPaging(data) {
    return axios({
      method: "post",
      url: "platform/Registeractivity/getLogListPaging",
      data: data,
    });
  },
  // 保存预约记录备注
  saveLogRemark(data) {
    return axios({
      method: "post",
      url: "platform/Registeractivity/saveLogRemark",
      data: data,
    });
  },
  // 预约记录退款
  refundLog(data) {
    return axios({
      method: "post",
      url: "platform/RegisterActivity/refundLog",
      data: data,
    });
  },
  /* **** 养生卡统计 **** */
  // 获取养生卡统计数据
  getStatData(data) {
    return axios({
      method: "post",
      url: "platform/Healthcard/getStatData",
      data: data,
    });
  },
  // 获取养生卡购买记录列表
  getUserLogListPaging(data) {
    return axios({
      method: "post",
      url: "platform/Healthcard/getUserLogListPaging",
      data: data,
    });
  },
  // 获取养生卡购买记录列表
  exportUserLogListExcel(data) {
    return axios({
      method: "post",
      url: "platform/Healthcard/exportUserLogListExcel",
      data: data,
    });
  },
  // 获取养生卡订单列表
  getUserOrderListPaging(data) {
    return axios({
      method: "post",
      url: "platform/Healthcard/getUserOrderListPaging",
      data: data,
    });
  },
  // 获取养身卡优惠券使用状态列表
  getUserCoupon(data) {
    return axios({
      method: "post",
      url: "platform/Healthcard/getUserCoupon",
      data: data,
    });
  },
  /* **** 医生新手任务 **** */
  // 医生任务详情
  doctorNewbieTaskDetail(data) {
    return axios({
      method: "post",
      url: "platform/Activity/doctorNewbieTaskDetail",
      data: data,
    });
  },
  /* **** 医生端活动配置---start **** */
  // 获取诊疗优惠券列表
  getCounponLists(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/getCounponLists",
      data: data,
    });
  },
  // 创建优惠券
  createCoupon(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/createCoupon",
      data: data,
    });
  },
  // 编辑优惠券
  editCoupon(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/editCoupon",
      data: data,
    });
  },
  // 修改优惠券排序
  updateCouponSort(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/updateCouponSort",
      data: data,
    });
  },
  // 修改优惠券状态
  updateCouponStatus(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/updateCouponStatus",
      data: data,
    });
  },
  // 获取优惠券详情
  getCouponInfo(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/getCouponInfo",
      data: data,
    });
  },
  // 用户领取优惠券详情
  getUserCouponList(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/getUserCouponList",
      data: data,
    });
  },
  // 优惠券发放记录
  couponDataSendLog(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/couponDataSendLog",
      data: data,
    });
  },
  // 修改优惠券发放状态
  updateCouponSend(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/updateCouponSend",
      data: data,
    });
  },
  // 给用户发放优惠券
  grantUserCoupon(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/grantUserCouponNew",
      data: data,
    });
  },
  /* **** 养身卡设置---start **** */
  // 获取养生卡列表
  getHealthCardConfig(data) {
    return axios({
      method: "post",
      url: "platform/Healthcard/getHealthCardConfig",
      data: data,
    });
  },
  // 添加养生卡配置
  addHealthCardConfig(data) {
    return axios({
      method: "post",
      url: "platform/Healthcard/addHealthCardConfig",
      data: data,
    });
  },
  // 编辑养生卡配置
  updateHealthCardConfig(data) {
    return axios({
      method: "post",
      url: "platform/Healthcard/updateHealthCardConfig",
      data: data,
    });
  },
  // 查看养生卡详情
  getHealthCardConfigInfo(data) {
    return axios({
      method: "post",
      url: "platform/Healthcard/getHealthCardConfigInfo",
      data: data,
    });
  },
  // 上架/下架
  updateHealthCardConfigStatus(data) {
    return axios({
      method: "post",
      url: "platform/Healthcard/updateHealthCardConfigStatus",
      data: data,
    });
  },
  // 查看优惠券
  getHealthCardConfigCoupon(data) {
    return axios({
      method: "post",
      url: "platform/Healthcard/getHealthCardConfigCoupon",
      data: data,
    });
  },
  /* **** 养身卡设置---end **** */
  /* **** 极速问诊设置---start **** */
  // 获取极速问诊配置
  getConsultFastConfig(data) {
    return axios({
      method: "post",
      url: "platform/guidance/getConsultFastConfig",
      data: data,
    });
  },
  // 修改极速问诊配置
  setConsultFastConfig(data) {
    return axios({
      method: "post",
      url: "platform/guidance/setConsultFastConfig",
      data: data,
    });
  },
  // 极速问诊订单
  getUserConsultFastList(data) {
    return axios({
      method: "post",
      url: "platform/guidance/getUserConsultFastList",
      data: data,
    });
  },
  // 极速问诊订单导出
  exportUserConsultFastList(data) {
    return axios({
      method: "post",
      url: "platform/guidance/exportUserConsultFastList",
      data: data,
    });
  },
  /* **** 极速问诊设置---end **** */
  /* **** 医生奖励统计---start **** */
  // 获取医生开方奖励统计
  getDoctorPrescriptionRewardList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/getDoctorPrescriptionRewardList",
      data: data,
    });
  },
  // 导出医生开方奖励统计
  exportDoctorPrescriptionRewardList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/exportDoctorPrescriptionRewardList",
      data: data,
    });
  },
  // 获取医生开方奖励医生列表
  getDoctorPrescriptionRewardDoctorList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/getDoctorPrescriptionRewardDoctorList",
      data: data,
    });
  },
  // 导出医生开方奖励医生列表
  exportDoctorPrescriptionRewardDoctorList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/exportDoctorPrescriptionRewardDoctorList",
      data: data,
    });
  },
  // 获取医生开方奖励患者列表
  getDoctorPrescriptionRewardPatientList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/getDoctorPrescriptionRewardPatientList",
      data: data,
    });
  },
  // 获取医生邀请用户阶梯奖励统计
  getDoctorLevelRewardList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/getDoctorLevelRewardList",
      data: data,
    });
  },
  // 导出医生邀请用户阶梯奖励统计
  exportDoctorLevelRewardList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/exportDoctorLevelRewardList",
      data: data,
    });
  },
  // 获取医生阶梯奖励医生列表
  getDoctorLevelRewardDoctorList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/getDoctorLevelRewardDoctorList",
      data: data,
    });
  },
  // 导出医生阶梯奖励医生列表
  exportDoctorLevelRewardDoctorList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/exportDoctorLevelRewardDoctorList",
      data: data,
    });
  },
  // 获取医生阶梯奖励患者列表
  getDoctorLevelRewardPatientList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/getDoctorLevelRewardPatientList",
      data: data,
    });
  },
  // 获取医生终身分佣奖励统计
  getDoctorForeverRewardList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/getDoctorForeverRewardList",
      data: data,
    });
  },
  // 导出医生终身分佣奖励统计
  exportDoctorForeverRewardList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/exportDoctorForeverRewardList",
      data: data,
    });
  },
  // 获取医生商城终身分佣奖励医生列表
  getDoctorForeverRewardDoctorList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/getDoctorForeverRewardDoctorList",
      data: data,
    });
  },
  // 导出医生商城终身分佣奖励医生列表
  exportDoctorForeverRewardDoctorList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/exportDoctorForeverRewardDoctorList",
      data: data,
    });
  },
  // 获取医生终身分佣奖励患者列表
  getDoctorForeverRewardPatientList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/getDoctorForeverRewardPatientList",
      data: data,
    });
  },
  // 获取医生推荐奖励统计
  getDoctorRecommendRewardList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/getDoctorRecommendRewardList",
      data: data,
    });
  },
  // 导出医生推荐奖励统计
  exportDoctorRecommendRewardList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/exportDoctorRecommendRewardList",
      data: data,
    });
  },
  // 获取医生推荐奖励医生列表
  getDoctorRecommendRewardDoctorList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/getDoctorRecommendRewardDoctorList",
      data: data,
    });
  },
  // 导出医生推荐奖励医生列表
  exportDoctorRecommendRewardDoctorList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/exportDoctorRecommendRewardDoctorList",
      data: data,
    });
  },
  // 获取医生推荐奖励患者列表
  getDoctorRecommendRewardPatientList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/getDoctorRecommendRewardPatientList",
      data: data,
    });
  },
  // 医生邀请用户数据统计列表
  getDoctorRecommendUserList(data) {
    return axios({
      method: "post",
      url: "/platform/doctorreward/getDoctorRecommendUserList",
      data: data,
    });
  },
  // 医生邀请用户数据统计导出
  exportDoctorRecommendUserList(data) {
    return axios({
      method: "post",
      url: "/platform/doctorreward/getDoctorRecommendUserExport",
      data: data,
    });
  },

  /* **** 医生奖励统计---end **** */

  /* **** 医生问诊统计---start **** */
  // 获取医生推荐奖励患者列表
  getDoctorConsultList(data) {
    return axios({
      method: "post",
      url: "platform/consult/getDoctorConsultList",
      data: data,
    });
  },
  // 导出医生问诊统计
  explodeDoctorConsultList(data) {
    return axios({
      method: "post",
      url: "platform/consult/explodeDoctorConsultList",
      data: data,
    });
  },
  // 医生问诊统计详情
  getDoctorConsultInfo(data) {
    return axios({
      method: "post",
      url: "platform/consult/getDoctorConsultInfo",
      data: data,
    });
  },

  // 导出医生问诊统计详情
  explodeDoctorConsultInfo(data) {
    return axios({
      method: "post",
      url: "platform/consult/explodeDoctorConsultInfo",
      data: data,
    });
  },
  // 医生处方统计详情
  getDoctorPreInfo(data) {
    return axios({
      method: "post",
      url: "platform/consult/getDoctorPreInfo",
      data: data,
    });
  },
  // 导出医生处方统计详情
  explodeDoctorPreInfo(data) {
    return axios({
      method: "post",
      url: "platform/consult/explodeDoctorPreInfo",
      data: data,
    });
  },
  //将结果添加到医生标签
  addDoctorConsultLabel(data) {
    return axios({
      method: "post",
      url: "platform/consult/addDoctorConsultLabel",
      data: data,
    });
  },
  // 获取更多筛选项/列表字段
  getDoctorConsultFieldList(data) {
    return axios({
      method: "post",
      url: "platform/consult/getDoctorConsultFieldList",
      data: data,
    });
  },
  /* **** 医生问诊统计---end **** */
  /* **** 仁心值活动统计---start **** */
  // 医生仁心活动基础列表
  doctorHeartActivityBaseList(data) {
    return axios({
      method: "post",
      url: "platform/activity/doctorHeartActivityBaseList",
      data: data,
    });
  },
  // 仁心值数据汇总
  doctorHeartActivitySummary(data) {
    return axios({
      method: "post",
      url: "platform/activity/doctorHeartActivitySummary",
      data: data,
    });
  },
  // 仁心值数据汇总导出
  doctorHeartActivitySummaryExport(data) {
    return axios({
      method: "post",
      url: "platform/activity/doctorHeartActivitySummaryExport",
      data: data,
    });
  },
  // 仁心值兑换情况
  doctorHeartExchange(data) {
    return axios({
      method: "post",
      url: "platform/activity/doctorHeartExchange",
      data: data,
    });
  },
  // 仁心值兑换情况导出
  doctorHeartExchangeExport(data) {
    return axios({
      method: "post",
      url: "platform/activity/doctorHeartExchangeExport",
      data: data,
    });
  },
  //商城兑换统计列表
  heartActivityOrder(data) {
    return axios({
      method: "post",
      url: "/platform/Activity/heartActivityOrder",
      data: data,
    });
  },
  //商城兑换统计列表导出
  heartActivityOrderExport(data) {
    return axios({
      method: "post",
      url: "/platform/Activity/heartActivityOrderExport",
      data: data,
    });
  },
  /* **** 仁心值活动统计---end **** */
  /* **** 券包---start **** */
  //  券包统计列表
  platformCouponGroupStatistics(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/platformCouponGroupStatistics",
      data: data,
    });
  },
  //  券包列表
  platformCouponGroupList(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/platformCouponGroupList",
      data: data,
    });
  },
  //  添加券包
  createPlatformCouponGroup(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/createPlatformCouponGroup",
      data: data,
    });
  },
  //  编辑券包
  updatePlatformCouponGroup(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/updatePlatformCouponGroup",
      data: data,
    });
  },
  //  编辑券包详情
  grantCouponGroupInfo(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon//grantCouponGroupInfo",
      data: data,
    });
  },
  //  发放券包
  grantPlatformCouponGroup(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/grantPlatformCouponGroup",
      data: data,
    });
  },
  //   检测是否发放过
  checkCouponGroupPhone(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/checkCouponGroupPhone",
      data: data,
    });
  },
  //  券包发放记录
  grantCouponGroupList(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/grantCouponGroupList",
      data: data,
    });
  },
  //  更新券包状态
  updatePlatformCouponStatus(data) {
    return axios({
      method: "post",
      url: "platform/Platformcoupon/updatePlatformCouponStatus",
      data: data,
    });
  },
  /* **** 券包---end **** */
  //  医生活动-商品兑换配置-商品列表
  getShopActivityGoodsList(data) {
    return axios({
      method: "post",
      url: "platform/shop/getShopActivityGoodsList",
      data: data,
    });
  },
};
